import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const scrollToSection = (sectionId) => {
    if (isHomePage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">
          <div className="header-content">
            <div className="logo">
              <h2>Purelife impex</h2>
              <span className="logo-subtitle">Premium Medical Equipment</span>
            </div>
            
            <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
              <ul className="nav-list">

                <li>
                  {isHomePage ? (
                    <button 
                      onClick={() => scrollToSection('home')}
                      className="nav-link"
                    >
                      Home
                    </button>
                  ) : (
                    <Link 
                      to="/#home"
                      className="nav-link"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Home
                    </Link>
                  )}
                </li>
                <li>
                  {isHomePage ? (
                    <button 
                      onClick={() => scrollToSection('about')}
                      className="nav-link"
                    >
                      About
                    </button>
                  ) : (
                    <Link 
                      to="/#about"
                      className="nav-link"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      About
                    </Link>
                  )}
                </li>
                <li>
                  <Link 
                    to="/products"
                    className="nav-link"
                    onClick={() => { setIsMobileMenuOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  >
                    Products
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/surgical-sets"
                    className="nav-link"
                    onClick={() => { setIsMobileMenuOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  >
                    Surgical Sets
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/catalogue"
                    className="nav-link"
                    onClick={() => { setIsMobileMenuOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  >
                    Catalogue
                  </Link>
                </li>
                <li>
                  {isHomePage ? (
                    <button 
                      onClick={() => scrollToSection('contact')}
                      className="nav-link"
                    >
                      Contact
                    </button>
                  ) : (
                    <Link 
                      to="/#contact"
                      className="nav-link"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      Contact
                    </Link>
                  )}
                </li>
              </ul>
            </nav>

            <div className="header-actions">
              {/* Removed Get Quote button per request */}
              <button 
                className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Floating Get Quote button for mobile removed per request */}
      <></>
    </>
  );
};

export default Header;